module.exports = __webpack_public_path__ + "static/media/css.7d4fe56a.png";